import httpClient from "@/http-client";

export const get = (Options = {}) => {
    return httpClient
        .get("/api/move-loan-write-offs", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = data => {
    return httpClient
        .post("/api/move-loan-write-offs", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const loanWriteOff = (Options = {}) => {
    return httpClient
        .get("/api/move-loan-write-offs/loan-write-offs", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const branches = (Options = {}) => {
    return httpClient
        .get("/api/move-loan-write-offs/branches", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const employeesByBranch = (Options = {}) => {
    return httpClient
        .get("/api/move-loan-write-offs/employees-by-branch", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default { get, store, loanWriteOff, branches, employeesByBranch };
